import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { CheckboxInput } from 'components/core';

const CommunicationSettings = ({
  optInEmail,
  optInSMS,
  optInPush,
  onOptInEmailClick,
  onOptInSMSClick,
  onOptInPushClick,
}) => {
  const { t } = useTranslation();

  const isEmailDisabled = optInEmail === null;
  const isSMSDisabled = optInSMS === null;
  const isPushDisabled = optInPush === null;

  const handleEmailClick = () => {
    if (!isEmailDisabled) {
      onOptInEmailClick();
    }
  };

  const handleSMSClick = () => {
    if (!isSMSDisabled) {
      onOptInSMSClick();
    }
  };

  const handlePushClick = () => {
    if (!isPushDisabled) {
      onOptInPushClick();
    }
  };

  return (
    <CheckboxContainer>
      <CheckboxWrapper $disabled={isEmailDisabled}>
        <CheckboxInput
          onClick={handleEmailClick}
          checked={optInEmail}
          option={{
            labelHeader: t('account.opt-in-email-updates-header', 'Email updates'),
            label: t('account.opt-in-email-updates', 'Get promotions, rewards, and special offers by email'),
            name: `textNotifications`,
            key: 'text-updates',
            height: 'auto',
          }}
        />
      </CheckboxWrapper>
      <CheckboxWrapper $disabled={isSMSDisabled}>
        <CheckboxInput
          onClick={handleSMSClick}
          checked={optInSMS}
          option={{
            labelHeader: t('account.opt-in-sms-updates-header', 'Text messages updates'),
            label: t('account.opt-in-sms-updates', 'Receive time-sensitive offers and rewards by text message'),
            name: `smsNotifications`,
            key: 'sms-updates',
            height: 'auto',
          }}
        />
      </CheckboxWrapper>
      <CheckboxWrapper $disabled={isPushDisabled}>
        <CheckboxInput
          onClick={handlePushClick}
          checked={optInPush}
          option={{
            labelHeader: t('account.opt-in-push-updates-header', 'Push notifications'),
            label: t('account.opt-in-push-updates', 'Get real-time alerts about deals and rewards'),
            name: `pushNotifications`,
            key: 'push-updates',
            height: 'auto',
          }}
        />
      </CheckboxWrapper>
    </CheckboxContainer>
  );
};

export default CommunicationSettings;

const CheckboxContainer = styled.div`
  margin-top: 21px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

const CheckboxWrapper = styled.div`
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  > div {
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')} !important;
  }

  label {
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')} !important;
  }

  input {
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')} !important;
  }
`;
